module.exports = __webpack_public_path__ + "c0bb4b0bb0fede094f6862a347f7e681.png";


//////////////////
// WEBPACK FOOTER
// ./js/index/img/about-2.png
// module id = 5
// module chunks = 0